export const REACTION_SETS = [
  {
    id: 'expressive',
    type: 'emoji',
    emojis: ['❤️', '😍', '🥳', '🥺', '🤪', '🔥']
  },
  {
    id: 'flags-filled-six',
    type: 'flag',
    filled: true,
    colors: ['#9caf9d', '#c3a9ce', '#b0cad6', '#cec4aa', '#a391cd', '#c8c8c8']
  },
  {
    id: 'flags-outline-six',
    type: 'flag',
    filled: false,
    colors: ['#9caf9d', '#c3a9ce', '#b0cad6', '#cec4aa', '#a391cd', '#c8c8c8']
  },
  {
    id: 'flags-filled-three',
    type: 'flag',
    filled: true,
    colors: ['#5f9870', '#e8c54b', '#b45147']
  },
  {
    id: 'flags-outline-three',
    type: 'flag',
    filled: false,
    colors: ['#5f9870', '#e8c54b', '#b45147']
  },
  {
    id: 'gentle',
    type: 'emoji',
    emojis: ['💜', '🩵', '⭐', '🌸', '🍼', '🧸']
  },
  {
    id: 'classic',
    type: 'emoji',
    emojis: ['💯', '👍🏼', '🔥', '✌🏼', '⚡', '😎']
  }
] as const;

export type ReactionSet = typeof REACTION_SETS[number];
export const DEFAULT_REACTION_SET = REACTION_SETS[0].id;
